import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./BankingDetails.css";
import HomeLeft from "../Components/HomeLeft";
import HomeRight from "../Components/HomeRight";
import mufg from './assets/mufg.png';
import yenicon from './assets/yenPoster.png';
import dollaricon from './assets/dollarPoster.png';
import paypalPoster from './assets/paypalPoster.png';

const BankingDetails = () => {
    return (
        <>
            <div className="row">
                {/* Middle Column */}
                <div className="col-lg-12 col-md-12 col-sm-12 middlecol">
                    <div className="container banking-details">
                        <p className="text-center mt-3">
                            <strong>
                                Please note that the banking details provided below are the only official banking information
                                associated with MI Trading Japan. We do not hold or use any other banking accounts. MI
                                Trading Japan will not be held responsible for any transactions or communications outside of
                                these details.
                            </strong>
                        </p>
                        <div className="text-center my-3">
                            <img src={mufg} alt="mufg" className="mufg-image img-fluid" />
                        </div>

                        {/* YEN ACCOUNT DETAILS */}
                        <div className="bank-section">
                            <img src={yenicon} alt="yenicon" className="yenicon-image img-fluid" />
                            <p>Beneficiary Banking Details (International Wire Transfers)</p>
                            <p>Kindly find the Complete Banking Details as below & do ensure the same banking details while transfer</p>
                            <table className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <td>BANK NAME</td>
                                        <td>MUFG BANK LTD.</td>
                                    </tr>
                                    <tr>
                                        <td>BANK NAME</td>
                                        <td>M.I TRADING CO., LTD</td>
                                    </tr>
                                    <tr>
                                        <td>ACCOUNT NUMBER</td>
                                        <td>605-0334568</td>
                                    </tr>
                                    <tr>
                                        <td>BRANCH CODE</td>
                                        <td>605</td>
                                    </tr>
                                    <tr>
                                        <td>BRANCH NAME</td>
                                        <td>TSUCHIURA</td>
                                    </tr>
                                    <tr>
                                        <td>BRANCH ADDRESS</td>
                                        <td>2 CHOME-10-1 CENTRAL TSUCHIURA</td>
                                    </tr>
                                    <tr>
                                        <td>SWIFT CODE</td>
                                        <td>BOTKJPJT</td>
                                    </tr>
                                </tbody>
                            </table>
                            <p>******ADDITIONAL INFORMATION INCASE YOUR BANK REQUESTS FOR IT*******</p>
                            <h3 className="text-center">INTERMEDIARY BANKING DETAILS</h3>
                            <table className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <td>BANK NAME</td>
                                        <td>THE BANK OF TOKYO MITSUBISHI UFJ, LTD</td>
                                    </tr>
                                    <tr>
                                        <td>BRANCH NAME</td>
                                        <td>NEW YORK BRANCH</td>
                                    </tr>
                                    <tr>
                                        <td>BRANCH ADDRESS</td>
                                        <td>1251 AVENUE OF THE AMERICAS, NEW YORK, NY 10020 -1104 U.S.A</td>
                                    </tr>
                                    <tr>
                                        <td>SWIFT CODE</td>
                                        <td>BOTKUS33</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* USD ACCOUNT DETAILS */}
                        <div className="bank-section">
                            <img src={dollaricon} alt="dollaricon" className="dollaricon-image img-fluid" />
                            <p>Beneficiary Banking Details (International Wire Transfers)</p>
                            <p>Kindly find the Complete Banking Details as below & do ensure the same banking details while transfer</p>
                            <table className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <td>BANK NAME</td>
                                        <td>MUFG BANK LTD.</td>
                                    </tr>
                                    <tr>
                                        <td>BENEFICIARY NAME</td>
                                        <td>M.I TRADING CO., LTD</td>
                                    </tr>
                                    <tr>
                                        <td>ACCOUNT NUMBER</td>
                                        <td>605-4616938</td>
                                    </tr>
                                    <tr>
                                        <td>BRANCH CODE</td>
                                        <td>605</td>
                                    </tr>
                                    <tr>
                                        <td>BRANCH NAME</td>
                                        <td>TSUCHIURA</td>
                                    </tr>
                                    <tr>
                                        <td>SWIFT CODE</td>
                                        <td>2 CHOME-10-1 CENTRAL TSUCHIURA</td>
                                    </tr>
                                    <tr>
                                        <td>SWIFT CODE</td>
                                        <td>BOTKJPJT</td>
                                    </tr>
                                </tbody>
                            </table>
                            <p>******ADDITIONAL INFORMATION INCASE YOUR BANK REQUESTS FOR IT*******</p>
                            <h3 className="text-center">INTERMEDIARY BANKING DETAILS</h3>
                            <table className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <td>BANK NAME</td>
                                        <td>THE BANK OF TOKYO MITSUBISHI UFJ, LTD</td>
                                    </tr>
                                    <tr>
                                        <td>BRANCH NAME</td>
                                        <td>NEW YORK BRANCH</td>
                                    </tr>
                                    <tr>
                                        <td>BRANCH ADDRESS</td>
                                        <td>1251 AVENUE OF THE AMERICAS, NEW YORK, NY 10020 -1104 U.S.A</td>
                                    </tr>
                                    <tr>
                                        <td>SWIFT CODE</td>
                                        <td>BOTKUS33</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* PayPal Option */}
                        <div className="text-center paypal-section">
                            <h4>OR</h4>
                            <p>
                                <a
                                    href="https://www.paypal.me/mitradingjapan"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={paypalPoster} alt="PayPal" className="paypal-logo img-fluid" />
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BankingDetails;
